import React from 'react';
import { OrgProductMultiSelect } from '../../../../components/team/OrgProductMultiSelect';
import { CustomSelect } from '../../../../shared/components/CustomSelect';
import { useTeamTab } from '../TeamTabContext';

export const RosterInviteModal: React.FC = () => {
  const {
    rosterInviteModalPerson,
    setRosterInviteModalPerson,
    rosterInviteEmail,
    setRosterInviteEmail,
    rosterInviteRole,
    setRosterInviteRole,
    rosterInviteProductIds,
    setRosterInviteProductIds,
    rosterInviteLoading,
    rosterInviteError,
    setRosterInviteError,
    inviteRoleOptions,
    visibleProductsSettings,
    handleSubmitRosterInvite,
  } = useTeamTab();

  if (!rosterInviteModalPerson) return null;

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="roster-invite-title"
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 10003,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(0,0,0,0.45)',
        padding: 16,
      }}
      onClick={() => !rosterInviteLoading && setRosterInviteModalPerson(null)}
    >
      <div
        style={{
          maxWidth: 480,
          width: '100%',
          padding: '20px 22px',
          borderRadius: 12,
          backgroundColor: 'var(--color-bg-surface)',
          border: '1px solid var(--color-border-strong)',
          boxShadow: '0 12px 40px rgba(0,0,0,0.18)',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <h4
          id="roster-invite-title"
          style={{
            margin: '0 0 10px 0',
            fontSize: '16px',
            fontWeight: 600,
            color: 'var(--color-text)',
          }}
        >
          Invite roster person
        </h4>
        <p
          style={{
            margin: '0 0 14px',
            fontSize: '13px',
            color: 'var(--color-text-secondary)',
            lineHeight: 1.45,
          }}
        >
          Links a Relix account when they accept. Products default to those already checked on this
          row.
        </p>
        <div className="form-group" style={{ marginBottom: 12 }}>
          <label className="form-label" htmlFor="rosterInviteEmail">
            Email
          </label>
          <input
            id="rosterInviteEmail"
            type="email"
            className="form-input"
            value={rosterInviteEmail}
            disabled={rosterInviteLoading}
            onChange={(e) => {
              setRosterInviteEmail(e.target.value);
              setRosterInviteError(null);
            }}
          />
        </div>
        <div className="form-group" style={{ marginBottom: 12 }}>
          <label className="form-label" htmlFor="rosterInviteRoleSel">
            Organization role
          </label>
          <CustomSelect
            id="rosterInviteRoleSel"
            value={rosterInviteRole}
            options={inviteRoleOptions}
            onChange={(val) => setRosterInviteRole(val as 'administrator' | 'member')}
            disabled={rosterInviteLoading}
          />
        </div>
        <OrgProductMultiSelect
          products={visibleProductsSettings}
          selectedIds={rosterInviteProductIds}
          onChange={setRosterInviteProductIds}
          disabled={rosterInviteLoading}
          legend="Products"
          hint="Leave unchecked to fall back on server defaults for invitations."
        />
        {rosterInviteError ? (
          <p
            style={{
              marginTop: 10,
              color: '#dc2626',
              fontSize: '13px',
            }}
          >
            {rosterInviteError}
          </p>
        ) : null}
        <div
          style={{
            display: 'flex',
            gap: 10,
            justifyContent: 'flex-end',
            marginTop: 16,
          }}
        >
          <button
            type="button"
            className="save-button"
            style={{
              backgroundColor: 'transparent',
              color: 'var(--color-text-secondary)',
              border: '1px solid var(--color-border-strong)',
            }}
            disabled={rosterInviteLoading}
            onClick={() => !rosterInviteLoading && setRosterInviteModalPerson(null)}
          >
            Cancel
          </button>
          <button
            type="button"
            className="save-button"
            style={{ backgroundColor: '#059669' }}
            disabled={rosterInviteLoading}
            onClick={() => void handleSubmitRosterInvite()}
          >
            {rosterInviteLoading ? 'Sending\u2026' : 'Send invite'}
          </button>
        </div>
      </div>
    </div>
  );
};
